import * as React from 'react';
import { SVGProps } from 'react';

const IconLightningBoltSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M9 0H3.944L2 7.5l2.462-.615L3 12h.5L10 4l-3.136.627L9 0z" />
  </svg>
);
export default IconLightningBoltSizeXs;
